module.exports = __webpack_public_path__ + "img/lichenming.92b84706.jpg";